const logos = {}

export default logos
